@for (action of proposedActions(); track action.eventId) {
  <ai-proposed-action
    #proposedActionRef
    [namespaceId]="action.namespaceId"
    [namespaceType]="action.namespaceType"
    [sessionId]="conversationId()"
    [eventId]="action.eventId"
    [superseded]="superseded()"
    (approved)="onApproved($event, proposedActionRef)"
    (rejected)="onRejected($event, proposedActionRef)"
    (changeRequested)="onChangeRequested()"
  />
}
